module.exports = __webpack_public_path__ + "img/usd-level-3.44f276fb.webp";